module.exports = __webpack_public_path__ + "img/suspend.0807f092.png";